// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__FoIEK","title":"ClientInsurance_title__1OfJ1","itemText":"ClientInsurance_itemText__2P2Mq"};